import { FaStar } from "react-icons/fa";

let Star = () => {
  return (
    <>
      <span className="text-deep-saffron">
        <FaStar />
      </span>
    </>
  );
};

export default Star;
